"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkScopeStr = exports.mkScopes = exports.onComplete = exports.onLanding = exports.wrapLoginResolver = exports.tenantToLoginInfo = exports.destroyStorage = exports.getIdInfo = exports.getAccessInfo = exports.getLoginInfo = exports.getTenant = exports.getIdToken = exports.getAccessToken = exports.jwtDecode = exports.jwtOrFail = exports.queryParse = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _midfetch2 = _interopRequireDefault(require("./midfetch"));

var _charUtils = require("./char-utils");

var consts = _interopRequireWildcard(require("./constants"));

var _nonce = require("./nonce");

var _drivers = _interopRequireDefault(require("./drivers"));

var _stateMachine = require("./state-machine");

var _errors = require("./errors");

/* global localStorage, sessionStorage */

/**
 * Parses a query string as provided in the url query or fragment segments.
 *
 * Obeys RFC3986, does not accumulate duplicated keys as arrays
 * eg. ?x=1&x=2 will produce {x: 1} and not produce {x: [1,2]}
 *
 * @param {string} queryString - the query string or fragment of a url
 * @returns {object|null} an object representation of the query string,
 */
var queryParse = function queryParse(queryString) {
  // if the string is missing, empty, or effectively empty, return the empty set
  if (!queryString || queryString === '#' || queryString === '?') {
    return {};
  } // strip the ? or # from the query or fragment if found


  if (queryString[0] === '?' || queryString[0] === '#') {
    queryString = queryString.substring(1);
  }

  return queryString.split(/[&;]/).map(function (pair) {
    return pair.split(/=/);
  }).reduce(function (a, _ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    // if v is missing but the key is present, it is null
    v = v === undefined ? null : v;

    if (!a[k]) {
      a[k] = v ? decodeURIComponent(v) : v;
    }

    return a;
  }, {});
};
/**
 * Tests if the token is a jwt and returns it, if it is not valid it returns null
 * @param {String} token - a possible jwt
 * @return {null|String} null if invalid, the token untouched if it is valid
 */


exports.queryParse = queryParse;

var jwtOrFail = function jwtOrFail(token) {
  var jwtRe = /[0-9a-zA-Z_-]+\.[0-9a-zA-Z_-]+\.[0-9a-zA-Z_-]+/;
  if (!token) return null;

  if (!token.match(jwtRe)) {
    console.error("token not a jwt; found ".concat(token));
    return null;
  }

  return token;
};
/**
 * JWT Token decoder
 * @param {string} token - a jwt token (this will crash if this isn't tested first by jwtOrFail)
 * @return {any} - a parsed jwt
 */


exports.jwtOrFail = jwtOrFail;

var jwtDecode = function jwtDecode(token) {
  return JSON.parse((0, _charUtils.b64DecodeUnicode)(token.split(/\./)[1]));
};

exports.jwtDecode = jwtDecode;

var getAccessToken = function getAccessToken() {
  return jwtOrFail(sessionStorage.getItem(consts.MID_ACCESS_TOKEN_KEY));
};

exports.getAccessToken = getAccessToken;

var getIdToken = function getIdToken() {
  return jwtOrFail(sessionStorage.getItem(consts.MID_ID_TOKEN_KEY));
};
/**
 * Retrieve the Tenant from the browser state if possible, otherwise null
 * @return {null|Tenant} if a tenant exists in the browser, return it, otherwise fail
 */


exports.getIdToken = getIdToken;

var getTenant = function getTenant() {
  var sessionTenantJson = sessionStorage.getItem(consts.MID_TENANT_KEY);

  if (!!sessionTenantJson) {
    try {
      return JSON.parse(sessionTenantJson);
    } catch (err) {
      console.error(_errors.errors.ERR_UNHANDLED('Session Tenant JSON is invalid, returning null'));
    }
  }

  return null;
};

exports.getTenant = getTenant;

var getLoginInfo = function getLoginInfo() {
  var loginInfoJson = localStorage.getItem(consts.MID_LOGIN_KEY);

  if (!!loginInfoJson) {
    try {
      return JSON.parse(loginInfoJson);
    } catch (err) {
      console.error(_errors.errors.ERR_UNHANDLED('Login Info JSON is invalid, returning null'));
    }
  }

  return null;
};

exports.getLoginInfo = getLoginInfo;

var getAccessInfo = function getAccessInfo() {
  var accessToken = getAccessToken();

  try {
    return !!accessToken ? jwtDecode(accessToken) : null;
  } catch (err) {
    console.error("unable to process access token ".concat(accessToken));
    return null;
  }
};
/**
 *
 * @return {any} - the id token information
 */


exports.getAccessInfo = getAccessInfo;

var getIdInfo = function getIdInfo() {
  var idToken = getIdToken();

  try {
    return !!idToken ? jwtDecode(idToken) : null;
  } catch (err) {
    console.error("unable to process id token ".concat(idToken));
    return null;
  }
};
/**
 * Destroys the current browser token/storage information.
 *
 * @param {MidCore} mid the midcore instance
 * @return {void}
 */


exports.getIdInfo = getIdInfo;

var destroyStorage = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(mid) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionStorage.removeItem(consts.MID_ID_TOKEN_KEY);
            sessionStorage.removeItem(consts.MID_ACCESS_TOKEN_KEY);
            sessionStorage.removeItem(consts.MID_NONCE);
            sessionStorage.removeItem(consts.MID_AUTH_EXPIRATION_TIME);
            sessionStorage.removeItem(consts.MID_TENANT_KEY);
            localStorage.removeItem(consts.MID_LOGIN_KEY);
            localStorage.removeItem(consts.MID_TENANT_KEY);
            localStorage.removeItem(consts.MID_USER_INFO_KEY);

            if (!mid.setCookie) {
              _context.next = 11;
              break;
            }

            _context.next = 11;
            return mid.setCookie(null);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function destroyStorage(_x) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 *
 * @param {MidCore} mid the midcore instance
 * @param {Tenant} tenant the tenant config
 * @return {*} the midfetch function that replicates Fetch API with headers set
 */


exports.destroyStorage = destroyStorage;

var makeMidFetch = function makeMidFetch(mid, tenant) {
  var headerHandler = function headerHandler() {
    return {
      'x-tenant': tenant.tenantId,
      authorization: "bearer ".concat(getAccessToken())
    };
  };

  var refreshHandler = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return mid.refresh();

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function refreshHandler() {
      return _ref4.apply(this, arguments);
    };
  }();

  return (0, _midfetch2["default"])(headerHandler, refreshHandler, mid.logout);
};
/**
 * Convert a tenant into a logininfo.
 *
 * @param {Tenant} tenant - the tenant to get login information for
 * @returns {LoginInfo} the login information for the provided tenant
 */


var tenantToLoginInfo = function tenantToLoginInfo(tenant) {
  if (!tenant) {
    return null;
  } else {
    return {
      appId: tenant.appId,
      domain: tenant.domain,
      oidcConfigUrl: tenant.oidcConfigUrl,
      authDriver: tenant.authDriver,
      audience: tenant.audience
    };
  }
};
/**
 * Wraps a login promise resolver with the appropriate information
 *
 * @param {Function} resolve - a promise's resolve method
 * @return {Function} - a function that take a mid core instance to wrap the promise resolve method with
 */


exports.tenantToLoginInfo = tenantToLoginInfo;

var wrapLoginResolver = function wrapLoginResolver(resolve) {
  return function (mid) {
    try {
      var tenant = getTenant();

      var _midfetch = makeMidFetch(mid, tenant);

      resolve({
        midfetch: _midfetch,
        tenant: tenant,
        accessToken: getAccessToken(),
        idToken: getIdToken(),
        accessInfo: getAccessInfo(),
        idInfo: getIdInfo()
      });
    } catch (err) {
      console.error('failed to resolve', err);
    }
  };
};
/**
 * Handle a redirect landing. This function has side-effects
 *
 * @param {MidCore} mid - the mid core instance
 * @param {LoginInfo} loginInfo - login configuration
 * @return {void} nothing
 */


exports.wrapLoginResolver = wrapLoginResolver;

var onLanding = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(mid, loginInfo) {
    var resp, driver, accessToken, idToken, tenant, idInfo;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (loginInfo) {
              _context3.next = 3;
              break;
            }

            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.FAIL).set(_stateMachine.ERROR_MSG, mid.errors.ERR_UNHANDLED('No valid login information found'));
            return _context3.abrupt("return");

          case 3:
            resp = queryParse(window.location.hash.substr(1));
            driver = (0, _drivers["default"])(mid, loginInfo);
            _context3.prev = 5;
            driver.redirectLanding(mid, resp, loginInfo);
            _context3.next = 15;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](5);
            _context3.next = 13;
            return destroyStorage(mid);

          case 13:
            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.FAIL).set(_stateMachine.ERROR_MSG, _context3.t0.message);
            return _context3.abrupt("return");

          case 15:
            accessToken = resp.access_token;
            idToken = resp.id_token;

            if (!(!jwtOrFail(accessToken) || !jwtOrFail(idToken))) {
              _context3.next = 22;
              break;
            }

            mid.sso = driver.attemptSSO(mid, loginInfo);

            if (!(!jwtOrFail(getAccessToken()) || !jwtOrFail(getIdToken()))) {
              _context3.next = 22;
              break;
            }

            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.FAIL).set(_stateMachine.ERROR_MSG, mid.errors.ERR_UNHANDLED('Invalid token(s)'));
            return _context3.abrupt("return");

          case 22:
            _context3.prev = 22;
            tenant = getTenant();
            tenant ? driver.verifyTokens(mid, tenantToLoginInfo(tenant), {
              accessToken: accessToken,
              idToken: idToken
            }) : driver.verifyTokens(mid, loginInfo, {
              accessToken: accessToken,
              idToken: idToken
            });
            _context3.next = 31;
            break;

          case 27:
            _context3.prev = 27;
            _context3.t1 = _context3["catch"](22);
            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.FAIL).set(_stateMachine.ERROR_MSG, mid.errors.ERR_UNHANDLED('Unable to validate tokens'));
            return _context3.abrupt("return");

          case 31:
            idInfo = jwtDecode(idToken);

            if ((0, _nonce.validateNonce)(idInfo.nonce)) {
              _context3.next = 35;
              break;
            }

            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.FAIL).set(_stateMachine.ERROR_MSG, mid.errors.ERR_MISCONFIGURATION('Nonce mismatch'));
            return _context3.abrupt("return");

          case 35:
            _context3.next = 37;
            return mid.setTokens(idToken, accessToken);

          case 37:
            mid.state = mid.state.set(_stateMachine.PHASE, _stateMachine.ST.TENANT_FETCH).set(_stateMachine.DATA, {
              idToken: idToken,
              accessToken: accessToken,
              loginInfo: loginInfo
            }).remove(_stateMachine.ERROR_MSG);

          case 38:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 9], [22, 27]]);
  }));

  return function onLanding(_x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Complete the login
 *
 * @param {MidCore} mid - the MidCore instance
 * @param {LoginInfo} loginInfo - the initial login information
 * @param {string} idToken - the id JWT
 * @param {string} accessToken - the access JWT
 * @param {Tenant} tenant - the selected Tenant
 *
 * @returns {void}
 */


exports.onLanding = onLanding;

var onComplete = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(mid, loginInfo, idToken, accessToken, tenant) {
    var driver, email;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return mid.setTokens(idToken, accessToken);

          case 2:
            mid.setTenant(tenant); // we have a situation where the loginInfo was likely a hub and the tenant has been selected. Refresh the tokens
            // then retry the completion

            if (!(tenant.appId !== loginInfo.appId)) {
              _context4.next = 11;
              break;
            }

            driver = (0, _drivers["default"])(mid, loginInfo);
            _context4.next = 7;
            return driver.email(mid, loginInfo);

          case 7:
            email = _context4.sent;
            mid.redirectLogin(email, tenantToLoginInfo(tenant));
            _context4.next = 13;
            break;

          case 11:
            // Just finish the login
            mid.onLoginResolve();

            if (mid.landingFn) {
              try {
                mid.landingFn({
                  midfetch: makeMidFetch(mid, tenant),
                  idToken: idToken,
                  accessToken: accessToken,
                  tenant: tenant
                });
              } catch (err) {
                console.error('error in landing function', err);
              }
            }

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function onComplete(_x4, _x5, _x6, _x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Creates a "scopes" set for the given array of scopes. If none are provided (ie a blank array or undefined)
 * then "openid" and "email" will be returned. If "scopes" is populated, it will return an array of the string
 * contents of "scopes" with "openid" and "email" appended. If "scopes" is not an array of strings, the behavior is
 * undefined. A Set operation is used to make sure there are no duplicates.
 *
 * @param {[string]|null} scopes an array of strings representing the scopes to request
 * @return {[string]} the set of scopes
 */


exports.onComplete = onComplete;

var mkScopes = function mkScopes(scopes) {
  var defaultScopes = ['openid', 'email'];

  if (scopes && scopes.length !== undefined) {
    return Array.from(new Set([].concat((0, _toConsumableArray2["default"])(scopes), defaultScopes)));
  } else {
    return defaultScopes;
  }
};
/**
 * Makes a scope set as in `mkScopes` however this produces a space-delimited string instead of an array.
 *
 * @param {[string]} scopes - an array of scopes
 * @return {string} - the space-delimited scopes string
 */


exports.mkScopes = mkScopes;

var mkScopeStr = function mkScopeStr(scopes) {
  return mkScopes(scopes).join(' ');
};

exports.mkScopeStr = mkScopeStr;